import React from 'react';
import { Card } from 'semantic-ui-react';
import OAuthAppsTable from '../../components/OAuthAppsTable';

const OAuthApp = () => {
  return (
    <div className='dashboard-container'>
      <Card fluid className='chart-card'>
        <Card.Content>
          <Card.Header className='header'>OAuth 应用</Card.Header>
          <OAuthAppsTable />
        </Card.Content>
      </Card>
    </div>
  );
};

export default OAuthApp;
